import { httpGet } from './request/requestApi';
const permissionControllerEndpoint = 'admin/listPermissions';
export class PermissionApi {
    static getPermissions() {
        return httpGet(permissionControllerEndpoint);
    }
}
